export default __webpack_public_path__ + "static/media/04.97ffdf5b.png";